import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=c942b9c4&scoped=true&"
import script from "./workspace.vue?vue&type=script&lang=js&"
export * from "./workspace.vue?vue&type=script&lang=js&"
import style0 from "./workspace.vue?vue&type=style&index=0&id=c942b9c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c942b9c4",
  null
  
)

export default component.exports